/* eslint no-unused-vars: 0 */

import Rellax from 'rellax';

const rellax = new Rellax('.js-rellax');
